// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMinimumInvestmentAmountPropertyDto
 */
export interface IMinimumInvestmentAmountPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IMinimumInvestmentAmountPropertyDto
     */
    minimum_investment_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IMinimumInvestmentAmountPropertyDto
     */
    minimum_investment_amount_state?: IMinimumInvestmentAmountPropertyDtoMinimumInvestmentAmountStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMinimumInvestmentAmountPropertyDtoMinimumInvestmentAmountStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IMinimumInvestmentAmountPropertyDto interface.
 */
export function instanceOfIMinimumInvestmentAmountPropertyDto(value: object): value is IMinimumInvestmentAmountPropertyDto {
    return true;
}

export function IMinimumInvestmentAmountPropertyDtoFromJSON(json: any): IMinimumInvestmentAmountPropertyDto {
    return IMinimumInvestmentAmountPropertyDtoFromJSONTyped(json, false);
}

export function IMinimumInvestmentAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMinimumInvestmentAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'minimum_investment_amount': json['minimum_investment_amount'] == null ? undefined : json['minimum_investment_amount'],
        'minimum_investment_amount_state': json['minimum_investment_amount_state'] == null ? undefined : json['minimum_investment_amount_state'],
    };
}

export function IMinimumInvestmentAmountPropertyDtoToJSON(json: any): IMinimumInvestmentAmountPropertyDto {
    return IMinimumInvestmentAmountPropertyDtoToJSONTyped(json, false);
}

export function IMinimumInvestmentAmountPropertyDtoToJSONTyped(value?: IMinimumInvestmentAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minimum_investment_amount': value['minimum_investment_amount'],
        'minimum_investment_amount_state': value['minimum_investment_amount_state'],
    };
}

